import { useContext, useEffect, useRef } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

export function useUnsavedGuard(dirty) {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const pending = useRef(dirty);
  pending.current = dirty;
  useEffect(() => {
    const message = "You have pending, failed, or invalid audit edits. Leave without saving them?";
    const approve = () => !pending.current || window.confirm(message);
    const unload = (event) => {
      if (pending.current) { event.preventDefault(); event.returnValue = ""; }
    };
    const originals = {};
    let index = window.history.state?.idx ?? 0;
    let restoring = false;
    ["push", "replace", "go"].forEach((method) => {
      originals[method] = navigator[method];
      navigator[method] = (...args) => {
        if (approve()) {
          const result = originals[method].apply(navigator, args);
          index = window.history.state?.idx ?? index;
          return result;
        }
      };
    });
    // Browser Back/Forward bypass navigator.go. Undo a rejected pop before Router handles it.
    const pop = (event) => {
      const next = event.state?.idx ?? 0;
      if (restoring) { restoring = false; event.stopImmediatePropagation(); return; }
      if (next !== index && !approve()) {
        event.stopImmediatePropagation(); restoring = true;
        window.history.go(index - next);
      } else index = next;
    };
    window.addEventListener("beforeunload", unload);
    window.addEventListener("popstate", pop, true);
    return () => {
      Object.entries(originals).forEach(([key, fn]) => { navigator[key] = fn; });
      window.removeEventListener("beforeunload", unload);
      window.removeEventListener("popstate", pop, true);
    };
  }, [navigator]);
}